export const DISTRIBUTION_NAME = "Distribution Name";
export const DISTRIBUTION_ID = "name";
export const DISTRIBUTION_ID_FRENCH = "nameFrench";
export const DISTRIBUTION_DESCRIPTION_ID = "description";
export const DISTRIBUTION_DESCRIPTION_ID_FRENCH = "descriptionFrench";
export const DISTRIBUTION_NAME_FRENCH = "Distribution Name (French)";
export const DISTRIBUTION_DATE = "distributionDate";
export const DISTRIBUTION_DATE_LABEL = "Distribution Date";
export const DISTRIBUTION_DESCRIPTION_LABEL = "Description";
export const DISTRIBUTION_DESCRIPTION_LABEL_FRENCH = "Description (French)";